import { Template } from "chq";
import { assurantVideoTemplates, bostonScientificVideoTemplates, comcastVideoTemplates, defaultVideoTemplates, intelliaVideoTemplates, intuitiveVideoTemplates, ircVideoTemplates, merckVideoTemplates, microsoftVideoTemplates, rtxVideoTemplates, santanderVideoTemplates, synopsysVideoTemplates, verizonVideoTemplates, zendeskVideoTemplates, premiseHealthVideoTemplates } from "../sidebar/tabs/template/templates";

const getVideoTemplatesByOrg = (organizationName: string): Template[] => {
  if (organizationName === "Assurant") {
    return [...assurantVideoTemplates, ...defaultVideoTemplates];
  }
  if (organizationName === "Boston Scientific") {
    return [...bostonScientificVideoTemplates, ...defaultVideoTemplates];
  }
  if (organizationName === "Intellia Therapeutics") {
    return intelliaVideoTemplates;
  }
  if (organizationName === "Intuitive") {
    return [...intuitiveVideoTemplates, ...defaultVideoTemplates];
  }
  if (organizationName === "Merck") {
    return [...merckVideoTemplates, ...defaultVideoTemplates];
  }
  if (organizationName === "Microsoft") {
    return [...microsoftVideoTemplates, ...defaultVideoTemplates];
  }
  if (organizationName === "Santander" || organizationName === "Santander Private Space") {
    return [...santanderVideoTemplates, ...defaultVideoTemplates];
  }
  if (organizationName === "Verizon") {
    return [...verizonVideoTemplates, ...defaultVideoTemplates];
  }
  if (organizationName === "Zendesk" || organizationName === "Zendesk Working Space") {
    return [...zendeskVideoTemplates, ...defaultVideoTemplates];
  }
  if (organizationName === "International Rescue Committee") {
    return [...ircVideoTemplates];
  }
  if (organizationName === "Comcast") {
    return [...comcastVideoTemplates, ...defaultVideoTemplates];
  }
  if (organizationName === "Synopsys" || organizationName === "Synopsys Private Workspace") {
    return [...synopsysVideoTemplates, ...defaultVideoTemplates];
  }
  if (organizationName === "RTX") {
    return [...rtxVideoTemplates, ...defaultVideoTemplates];
  }
  if (organizationName === "Premise Health") {
    return [...premiseHealthVideoTemplates];
  }
  return defaultVideoTemplates;
};

export default getVideoTemplatesByOrg;
